module.exports = {
  __depends__: [
    require(136),
    require(155),
    require(106)
  ],
  __init__: [ 'resize' ],
  resize: [ 'type', require(150) ]
};
